import Section from "@/Components/LayoutComponents/Section";
import React, { useState } from "react";
import TechStackCard from "./TechStackCard";
import { toWebp } from "@/utils/common";

interface TechStackProps {
  data?: any;
}

const TechStack: React.FC< TechStackProps> = ({ data  }) =>  {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  // Map backend data to component props
  const techStackData =
    data?.cards?.map((card: any, index: number) => ({
      sectionTitle: card.title || "",
      variant: index % 2 === 0 ? "blue" : "green",
      items:
        card.technologies?.map((tech: any, index: number) => ({
          id: tech.id || index + 1,
          content: tech?.language || "",
          iconImage: tech?.Image
            ? `${baseUrl}${toWebp(tech.Image.data.attributes.url)}`
            : toWebp("/images/ServicesInner/Angular.svg"),
        })) || [],
    })) || [];

  const sectionTitle = data?.title || "Tech Stack";
  const sectionDescription =
    data?.sub_title ||
    "We Implement the Following AI/ML Development Technologies";

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <Section>
      <div className="container relative">
        <div className="lg:flex justify-between items-start gap-[30px]">
          <div className="xl:max-w-[390px] lg:max-w-[265px] max-w-full lg:text-start text-center lg:sticky top-28">
            <h2 className="lg:text-heading-1 text-heading-3 font-bold text-primary-text">
              {sectionTitle}
            </h2>
            <p className="text-secondary-text text-subtitle-2 font-regular mt-6">
              {sectionDescription}
            </p>
          </div>
          <div className="w-full flex flex-col gap-[30px] lg:mt-0 mt-8">
            {techStackData.map((section: any, i: number) => (
              <TechStackCard
                key={i}
                index={i}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
                sectionTitle={section?.sectionTitle}
                variant={section?.variant}
                items={section?.items}
              />
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};
export default TechStack;